import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductConfigurationAttributesContext } from "./ProductConfigurationAttributesContext"

export const ProductConfigurationCopyToClipboard = React.memo(() => {
  const { t } = useTranslation()
  const { copyToClipboard, isLoading } =
    useProductConfigurationAttributesContext()

  return (
    <Button
      variant={ButtonVariant.SECONDARY}
      onClick={copyToClipboard}
      label={t("General.CopyToClipboard")}
      icon={IconName.DUPLICATE}
      iconSize={IconSize.SMALL}
      className="btn--borderless btn--bleed"
      disabled={isLoading}
    />
  )
})

ProductConfigurationCopyToClipboard.displayName =
  "ProductConfigurationAttributes.CopyToClipboard"
